import { create } from "zustand";
import getMockData from "./data";

const initialState = {
    loading: false,
};

const useStore = create((set) => {
    getMockData(initialState);
    initialState.loading = false;

    return {
        ...initialState,
    };
});

export default useStore;
